














import { computed, defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "LoggedInByProxyBar",
  emits: ["logout"],
  props: {
    companyName: {
      type: String,
      default: ""
    }
  },
  setup(props, { emit }) {
    const messageText = computed(() => {
      return `${props.companyName} として代理ログイン中`;
    });

    const handleClickedLogOut = () => {
      emit("logout");
    };

    return {
      messageText,
      handleClickedLogOut
    };
  }
});
